import { ListingModalRef } from "components/ButtonModal";
import { useCreateTccStore } from "context/CreateTccContext";
import { useContext } from "react";
import { RefObject } from "react";
import { CreateTccActions } from "states/create-tcc";
import AuthContext from "../../../../context/AuthContext";
import CharLimitCounter from "components/text-fields/CharLimitCounter";
import TextFieldWithLimit from "components/text-fields/TextFieldWithLimit";

const ApproveConfirmationModal = ({
  onConfirm,
  parentModalRef,
}: {
  onConfirm: (...args: any) => any;
  parentModalRef: RefObject<ListingModalRef>;
}) => {
  const { state, dispatch } = useCreateTccStore();
  const authCtx = useContext(AuthContext);
  const hasPermission = authCtx?.hasPermission;
  const hasGlobalApproverPermission: boolean = hasPermission(
    "api.global_approver_tcc_request",
  );

  const handleApproveComment = (item: any) => {
    dispatch(CreateTccActions.setApproveComment(item.target.value));
  };

  return (
    <div className="d-flex flex-column" style={{ minHeight: 250 }}>
      <span className="mb-2 text-center black-text">
        Before {!hasGlobalApproverPermission && "approving"}{" "}
        {hasGlobalApproverPermission && "creating TCC"} you can leave a useful
        comment about this TCC request <strong>(optional)</strong>
      </span>
      <div className="row">
        <TextFieldWithLimit
          spacing="col-12"
          label="Comment"
          limit={1000}
          value={state.approveComment}
          onChange={handleApproveComment}
          invalidMessage="The comment must have a maximum of 1000 characters"
        />
      </div>

      <div className="d-flex justify-content-end mt-auto gap-3">
        <input
          type="submit"
          onClick={parentModalRef.current?.closeModal}
          className="btn btn-secondary"
          value={"Cancel"}
        />

        <input
          type="submit"
          onClick={onConfirm}
          className="btn btn-primary"
          value={hasGlobalApproverPermission ? "Create TCC" : "Approve"}
          disabled={state.approveComment.length > 1000}
        />
      </div>
    </div>
  );
};

export default ApproveConfirmationModal;
